module.exports = __webpack_public_path__ + "img/6-l.6e896ac6.png";